import React, { useEffect, useState } from "react";
import axios from "axios";
import TailwindLoadingSpinner from "../../../tailwind-ui/components/TailwindLoadingSpinner";
import RoleBindingsTable from "./RoleBindingsTable";
import UsageChart from "./UsageChart";
import TokenLogsActivity from "./TokenLogsActivity";

const K8TokenAnalytics = ({ logsURL, usageURL, roleBindingURL }) => {
  const [usageData, setUsageData] = useState({});
  const [roleBindingData, setRoleBindingData] = useState([]);
  const [logsData, setlogsData] = useState([]);

  const [loading, setLoading] = useState(true);

  const getLogsURL = async () => {
    try {
      const res = await axios.get(logsURL);
      setlogsData(res.data);
    } catch (err) {
      console.error("Error fetching usage data:", err);
    } finally {
      setLoading(false);
    }
  };

  const getUsage = async () => {
    try {
      const res = await axios.get(usageURL);
      setUsageData(res.data);
    } catch (err) {
      console.error("Error fetching usage data:", err);
    } finally {
      setLoading(false);
    }
  };

  const getRoleBinding = async () => {
    try {
      const res = await axios.get(roleBindingURL);
      setRoleBindingData(res.data || []);
    } catch (err) {
      console.error("Error fetching role binding data:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getUsage();
  }, [usageURL]);

  useEffect(() => {
    getRoleBinding();
  }, [roleBindingURL]);
  useEffect(() => {
    getLogsURL();
  }, [logsURL]);

  if (loading) {
    return (
      <div className="p-6 text-center text-gray-600">
        <TailwindLoadingSpinner />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {logsData?.length > 0 && (
        <div className="p-4 bg-white rounded-lg shadow">
          <TokenLogsActivity logs={logsData} />
        </div>
      )}

      <div className="p-4 bg-white rounded-lg shadow">
        <h2 className="mb-4 text-lg font-semibold">Top Usages</h2>
        <div className="flex flex-wrap -mx-2">
          {Object.entries(usageData).map(([key, value]) => (
            <UsageChart key={key} title={key} data={value} />
          ))}
        </div>
      </div>
      {roleBindingData?.length > 0 && (
        <div className="p-4 bg-white rounded-lg shadow">
          <RoleBindingsTable bindings={roleBindingData} />
        </div>
      )}
    </div>
  );
};

export default K8TokenAnalytics;
